(function ($) {

    // Menu animations
    $('#trigger').on('click', function () {

        if ($(this).hasClass('open')) {

            $(this).removeClass('open');
            $('body').removeClass('c-scroll-disable');
            $('#siteLogo').animate({}, 300, function () {
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 300, function () {
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({ top: '-100vh' }).fadeOut(300);
        } else {

            $('body').addClass('c-scroll-disable');
            $(this).addClass('open');
            $('#mainMenu').fadeIn(100).animate({ top: '0' });
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 300, function () {
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 300, function () {
                $(this).css('z-index', 90);
            });
        }
    });

    $('#mainMenu a').on('click', function () {

        if ($('#trigger').hasClass('open')) {

            $('#trigger').removeClass('open');
            $('body').removeClass('c-scroll-disable');
            $('#siteLogo').animate({}, 500, function () {
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 500, function () {
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({ top: '-100vh' }).fadeOut(500);
        }
    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });

    // Accordions
    $(function () {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function () {
            if ($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if ($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });

    // Initiate aos animations
    AOS.init();

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();
})(jQuery);
